import { createContext, useContext, useState, ReactNode, useCallback, useEffect } from 'react';

interface PageTitleContextType {
  title: string;
  setTitle: (title: string) => void;
  resetTitle: () => void;
}

const PageTitleContext = createContext<PageTitleContextType | undefined>(undefined);

export function PageTitleProvider({ children }: { children: ReactNode }) {
  const [title, setTitle] = useState('');

  const resetTitle = useCallback(() => {
    setTitle('');
  }, []);

  useEffect(() => {
    // SOLO se un componente imposta un titolo: altrimenti preserva il <title> SSR
    // (i post del blog e le listing non chiamano setTitle; sovrascriverlo con il
    // default faceva vedere a Google 19 articoli tutti con lo stesso title)
    if (title) {
      document.title = `${title} | Sea Level Traders`;
    }
  }, [title]);

  return (
    <PageTitleContext.Provider value={{ title, setTitle, resetTitle }}>
      {children}
    </PageTitleContext.Provider>
  );
}

export function usePageTitle() {
  const context = useContext(PageTitleContext);
  if (!context) {
    throw new Error('usePageTitle must be used within a PageTitleProvider');
  }
  return context;
}
